export default __webpack_public_path__ + "static/media/12-EXT-(4-2).c6ce55a4.jpg";